import store from "@/store"
import { Uploads } from "@/store/modules"
import API from "./API"

const endpoint = "/uploads/"
const endpoint1 = "/agriwebbdata"
const endpointPasture = "/uploads/import_enrichedad_ranching_data/"
const uploadsByFieldEndpoint = "/uploads-by-field/"
const endpointHerdPasture = "/uploads/import_enrichedag_herd_forage_data/"

const get = payload =>
  API.get(endpoint + "?page=" + payload.currentPage, {
    params: payload,
  })

const getAgriWebData = (agriwebbPastureId) => 
  API.get(`${endpoint1}?pasture_id=${agriwebbPastureId}`)

const getByField = payload =>
  API.post(
    `${uploadsByFieldEndpoint}fetch_uploads/` + "?page=" + payload.currentPage,
    payload
  )

const post = payload => {
  return API.post(`${endpoint}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const postPasture = payload => {
  return API.post(`${endpointPasture}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const postPastureHerd = payload => {
  return API.post(`${endpointHerdPasture}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const updateBoundary = payload => {
  return API.post(`${endpoint}update_boundary/`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const updateRanchBoundary = payload => {
  return API.post(`${endpoint}update_ranching_boundary/`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 240000,
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const updateRanchPaddocks = payload => {
  return API.post(`${endpoint}update_ranching_paddocks/`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const uploadEvidencing = payload => {
  return API.post(`${endpoint}upload_evidencing/`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const uploadEnrich = payload => {
  return API.post(`${endpoint}update_enrichedag_ranching_boundary/`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress(progressEvent) {
      const percentComplete = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      )
      store.commit(Uploads.Mutations.setUploadPercentage, percentComplete)
    },
  })
}

const updateRanching = payload => {
  return API.post(`${endpoint}update_ranching/`, payload)
}

const deleteUpload = uploadId => API.delete(`${endpoint}${uploadId}/`)

const downloadDataSet = uploadByFieldId =>
  API.post(`${uploadsByFieldEndpoint}${uploadByFieldId}/get_signed_url/`)

const shipFileImport = (payload) => {
  return API.post(`/create-shape-file/create_shape_file_for_pasture/`, payload)
}

const getUserAgriwebbAPIKey = () => {
  return API.get(`/get_user_agriwebb_api_key/`)
}

const createUserAgriwebbAPIKey = payload => {
  return API.post(`/create_user_agriwebb_api_key/`, payload)
}

const getAgriwebbPastureOptions = () => {
  return API.get(`get_agri_webb_pastures`)
}

export default {
  get,
  getAgriWebData,
  getByField,
  post,
  postPasture,
  updateRanching,
  updateBoundary,
  updateRanchBoundary,
  updateRanchPaddocks,
  deleteUpload,
  downloadDataSet,
  uploadEvidencing,
  shipFileImport,
  uploadEnrich,
  getUserAgriwebbAPIKey,
  createUserAgriwebbAPIKey,
  getAgriwebbPastureOptions,
  postPastureHerd
}
